import $ from 'jquery';
import React from 'react';

import {FromServerNoteLinkedFile} from 'notebook/util/NoteUtilConstants';
import notifications from 'notifications';
import * as TrayTaskActions from 'tray/TrayTaskActions';
import * as TrayTaskConstants from 'tray/TrayTaskConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import TFIDAO from './TFIDAO';

function onUploadFailed(taskId: string, response: Response): void {
  notifications.notifyError(response);
  const error = 'An error occurred while uploading the file. Please try again.';
  TrayTaskActions.updateTrayTask(taskId, {progress: TrayTaskConstants.FAILURE_PROGRESS, error});
}

/** @package */
export function importForNote(
  _noteId: string,
  tfiObject: {accountId: string; id: string; name: string},
  taskId: string
): JQueryPromise<FromServerNoteLinkedFile> {
  return TFIDAO.importFile({
    accountId: tfiObject.accountId,
    fileId: tfiObject.id,
    fileName: tfiObject.name,
  })
    .progress((progress) => {
      TrayTaskActions.updateTrayTask(taskId, {progress});
    })
    .then(({noteLinkedObject}: {noteLinkedObject: FromServerNoteLinkedFile}) => {
      if (noteLinkedObject != null) {
        return noteLinkedObject;
      } else {
        notifications.error('File has been removed');
        return $.Deferred<FromServerNoteLinkedFile>().reject().promise();
      }
    })
    .done((_noteLinkedObject) => {
      if (taskId != null) {
        TrayTaskActions.updateTrayTask(taskId, {
          progress: TrayTaskConstants.SUCCESS_PROGRESS,
          duration: 5,
        });
      }
    })
    .fail(notifications.notifyError);
}

export function createTaskAndImportFile(
  noteId: string,
  tfiObject: {accountId: string; id: string; name: string}
): {taskId: string; fileUploadDeferred: JQueryPromise<FromServerNoteLinkedFile>} {
  const taskId = TrayTaskActions.createTrayTask({
    icon: <BenchlingIcon icon="paperclip" />,
    heading: tfiObject.name,
  });
  const fileUploadDeferred = importForNote(noteId, tfiObject, taskId).fail(onUploadFailed.bind(null, taskId));
  return {taskId, fileUploadDeferred};
}
